import React from 'react';

export function useAreSomeOptionalsSelected(selectedExtraServices) {
  return React.useMemo(() => {
    return Object.values(selectedExtraServices).some(({ status }) => !!status);
  }, [selectedExtraServices]);
}
